import './ContentGroupsList.scss';
import { useState, useEffect, useRef, useMemo } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const presetColors = [
	'#d9a6a6', // Muted Coral
	'#a0b6d8', // Muted Cornflower Blue
	'#b2d8b2', // Muted Pale Green
	'#d8c687', // Muted Gold
	'#c8a0c8', // Muted Plum
	'#a6d8d9', // Muted Aqua
	'#d9a6b6', // Muted Rose
	'#a6d9a6', // Muted Mint
	'#b6a6d9', // Muted Lavender
	'#d9b6a6', // Muted Peach
	'#d9d8a6', // Muted Sand
	'#b6d9a6', // Muted Olive
	'#a6b6d9', // Muted Sky Blue
	'#d8a6c8', // Muted Pink
	'#a6d9c8', // Muted Teal
	'#d9c8a6', // Muted Tan
	'#c8d9a6', // Muted Lime
	'#a6d9b6', // Muted Sea Green
	'#d9a6d8', // Muted Orchid
	'#d9b6d8'  // Muted Lilac
];

const ContentGroupsList = ({ contentGroups }) => {
	const [showList, setShowList] = useState(false);
	const listRef = useRef(null);

	const groupCount = contentGroups?.length || 0;

	let summaryText = 'No Groups Assigned';
	if (groupCount === 1) {
		summaryText = '1 Group Assigned';
	}
	else if (groupCount > 1) {
		summaryText = `${groupCount} Groups Assigned`;
	}

	const handleToggleList = () => {
		if (groupCount > 0) {
			setShowList(prev => !prev);
		}
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (listRef.current && !listRef.current.contains(event.target)) {
				setShowList(false);
			}
		};

		if (showList) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [showList]);

	const offerColorMap = useMemo(() => {
		const map = {};
		let colorIndex = 0;

		for (const group of contentGroups) {
			const offer = group.Offer?.Name;
			if (offer && !map[offer]) {
				map[offer] = presetColors[colorIndex % presetColors.length];
				colorIndex++;
			}
		}

		return map;
	}, [contentGroups]);

	return (
		<div className={`content-groups`} ref={listRef}>
			<p
				onClick={handleToggleList}
				className={`summary ${showList ? 'open' : 'closed'} ${groupCount > 0 ? "clickable" : ""}`}
			>
				{summaryText}
				{groupCount > 0 && (
					<span className={`summary-icon ${showList ? 'open' : 'closed'}`}>
						<FontAwesomeIcon icon={faChevronDown} />
					</span>
				)}
			</p>

			{showList && (
				<div className="content-groups-list">
					{contentGroups.map((group, index) => {
						const offerName = group.Offer?.Name || 'Unknown Offer';
						const color = offerColorMap[offerName] || '#ccc';
						return (
							<div key={index} className="content-groups-list-group">
								<div className="content-groups-list-group-icon-wrapper">
									<span
										className="content-groups-list-group-colour"
										style={{ backgroundColor: color }}
									></span>
									<div className="content-groups-list-group-offer">
										<p>{offerName}</p>
									</div>
								</div>
								<p>{group.Name}</p>
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default ContentGroupsList;
